import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/HomePage/OverviewSection.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import ChartSvg from 'icons/chart.svg'
import SavingsSvg from 'icons/savings.svg'
import InvestmentSvg from 'icons/investment.svg'
import CreditScoreSvg from 'icons/creditscore.svg'
import MortgageSvg from 'icons/mortgage.svg'
import AlertSvg from 'icons/alert.svg'
import ReactSvgIcon from 'icons/*.svg'

type FeatureDescriptor = {
  name: string
  icon: typeof ReactSvgIcon
  text: string
}

const FEATURE_DESCRIPTORS: FeatureDescriptor[] = [
  {
    name: 'Net Worth Tracking',
    icon: ChartSvg,
    text: 'Link your accounts or add them manually to track your entire financial life.',
  },
  {
    name: 'Easy Budgeting',
    icon: SavingsSvg,
    text: 'Set spending limits and income goals using your peers as a benchmark.',
  },
  {
    name: 'Cash Flow Projections',
    icon: InvestmentSvg,
    text: 'Peek into the future with projections based on your transaction patterns.',
  },
  {
    name: 'Free Credit Monitoring',
    icon: CreditScoreSvg,
    text: 'Track your credit score and get alerts when accounts are added to your credit file.',
  },
  {
    name: 'Interest Rates Analysis',
    icon: MortgageSvg,
    text: 'Compare rates with your peers and see how much you can save.',
  },
  {
    name: 'Account Alerts',
    icon: AlertSvg,
    text: 'Enjoy life, we\'ll alert you if we detect new fees or credit score changes.',
  },
]

const OverviewSection: FC = () => {
  const lineBreakChild = (
    <span className={ styles.lineBreak }>{ ' ' }</span>
  )

  return (
    <section className={ cn(styles.overviewSection) }>
      <h2 className={ styles.header }>
        Plus,{ lineBreakChild }get everything you need to manage your money.
      </h2>
      <ul className={ styles.features }>
        {
          FEATURE_DESCRIPTORS.map(({ name, text, icon }) => {
            return (
              <li key={ name } className={ styles.feature }>
                <h4 className={ styles.featureHeader }>
                  <div className={ styles.iconWrapper }>
                    <SvgIcon src={ icon } />
                  </div>
                  { name }
                </h4>
                <p className={ styles.featureText }>
                  { text }
                </p>
              </li>
            )
          })
        }
      </ul>
    </section>
  )
}

export default OverviewSection
